/* eslint-disable camelcase */
import { FC } from 'react';

import { EvMarkdownViewer, EvTag, EvTitle, TAG_STATUS } from '@evinced-private/ui-common';

import { formatDate } from '../../../components/common/helpers/DateFormatHelper';
import { ReleaseNote } from '../../../types/release-notes/ReleaseNote';

import { ReleaseNoteCardSkeleton } from './ReleaseNoteCardSkeleton';

import './ReleaseNoteCard.scss';

interface IReleaseNoteCardProps {
	releaseNotes: ReleaseNote[];
	isLoading: boolean;
	isError?: boolean;
}

export const ReleaseNoteCard: FC<IReleaseNoteCardProps> = ({
	releaseNotes,
	isLoading,
	isError
}: IReleaseNoteCardProps) => {
	if (isLoading) {
		return <ReleaseNoteCardSkeleton />;
	}

	if (isError) {
		return null;
	}

	if (!releaseNotes || releaseNotes.length === 0) {
		return (
			<div className="release-notes-content-card">
				<div className="changelog-section">
					<EvTitle className="patch-name" headingLevel={3} titleText="No Release Notes" />
					<p className="patch-date">No release notes available for this product yet.</p>
				</div>
			</div>
		);
	}

	return (
		<>
			{releaseNotes.map((releaseNote) => {
				const { id, title, version, published_at, content } = releaseNote;
				const tagId = `tag_${id}`;
				return (
					<div key={id} className="release-notes-content-card">
						<div className="changelog-section">
							<div className="patch-header">
								<EvTitle
									className="patch-name"
									headingLevel={3}
									titleText={title}
									ariaDescribedBy={version ? tagId : undefined}
								/>
								{version && (
									<div id={tagId} className="info-tag">
										<EvTag text={`V${version}`} status={TAG_STATUS.INFO} showLabel={false} />
									</div>
								)}
							</div>
							<div className="patch-date">
								{published_at ? formatDate(published_at) : 'Release date not available'}
							</div>
							{content && (
								<div className="patch-content">
									<EvMarkdownViewer initialValue={content} />
								</div>
							)}
						</div>
					</div>
				);
			})}
		</>
	);
};
